module.exports = __webpack_public_path__ + "img/agoric-light.857a4245.svg";